/**
 *
 * Asynchronously loads the component for ChooseBusiness
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ChooseBusiness = lazyLoad(
  () => import('./index'),
  module => module.ChooseBusiness,
);
